<template>
  <div>
    
    <Head v-if="!isIndex" :Index="isIndex"/>
    <WapHeader v-else :Index="isIndex"/>
    <keep-alive>
      <router-view :key="$route.path" v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view :key="$route.path" v-if="!$route.meta.keepAlive"/>
    <Bottom v-if="!isIndex" :Index="isIndex"/>
    <WapBottom v-else :Index="isIndex"/>
  </div>
</template>
<script>
import Head from '@/components/header'
import WapHeader from '@/components/wapHeader'
import Bottom from '@/components/bottom'
import WapBottom from '@/components/wapBottom'
export default {
  components: {
    Head,
    Bottom,
    WapHeader,
    WapBottom
  },
  data () {
    return {
      isIndex: false,
      columnId: this.$route.query.columnId,
      bannerObj1: {}
    }
  },
  created () {
      // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  methods: {
     handleMediaQueryChange(event) {
        let screenWidth =
            window.innerWidth || document.documentElement.clientWidth;
        if (event.matches) {
            this.isIndex = false;
        } else {
            this.isIndex = true;
            this.screenWidth = screenWidth;
        }
    },
  },
    beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
}
</script>
<style scoped>
.menu-box{z-index: 150; position: relative;}
</style>
